// extracted by mini-css-extract-plugin
export default {"loginCon":"styles_loginCon__lz-vE","body":"styles_body__pXDfh"};